module.exports = __webpack_public_path__ + "img/careers.0329aa3.jpg";